import React from 'react'

export default function MainFooter() {
  return (
    <footer>
        <h3 className="footerMargin">
          Add us on <a href="https://twitter.com/JenniferPiwons1" className="footer">Twitter</a>! <br/> 
          Powered by <a href= "https://betterdoctor.com/partners/" className="footer"> Better Doctor API</a> <br/>
        </h3>
  </footer>
  )
}     
